import { create } from 'zustand';
import type { ReactNode } from 'react';

/**
 * Promise tabanlı diyaloglar (Octo.Mobile resolver deseni / Blazor OctoConfirmDialog+OctoShowDialog):
 *   const ok = await dialogs.confirm({ title, message, kind: 'delete' });
 *   await dialogs.error({ message, detail, sql });
 * DialogHost bileşeni uygulama kökünde bir kez mount edilir (App.tsx): OctoLab ve
 * Node görünümü ana kabuğu kullanmıyor, host kabukta olsaydı oralarda çalışmazdı.
 */
export type ConfirmKind = 'standard' | 'delete';
export interface ConfirmRequest {
  title?: string;
  message: ReactNode;
  kind?: ConfirmKind;
  okText?: string;
  cancelText?: string;
}
export interface ErrorRequest {
  title?: string;
  message: ReactNode;
  detail?: string | null;
  sql?: string | null;
  tone?: 'danger' | 'warning' | 'info';
}

interface Pending<T> {
  id: number;
  resolve: (v: T) => void;
}
interface DialogState {
  confirm: (ConfirmRequest & Pending<boolean>) | null;
  error: (ErrorRequest & Pending<void>) | null;
  openConfirm: (req: ConfirmRequest) => Promise<boolean>;
  openError: (req: ErrorRequest) => Promise<void>;
  resolveConfirm: (v: boolean) => void;
  resolveError: () => void;
}
let seq = 1;
export const useDialogStore = create<DialogState>((set, get) => ({
  confirm: null,
  error: null,
  openConfirm: (req) => new Promise<boolean>((resolve) => set({ confirm: { ...req, id: seq++, resolve } })),
  openError: (req) => new Promise<void>((resolve) => set({ error: { ...req, id: seq++, resolve } })),
  resolveConfirm: (v) => {
    const c = get().confirm;
    set({ confirm: null });
    c?.resolve(v);
  },
  resolveError: () => {
    const e = get().error;
    set({ error: null });
    e?.resolve();
  },
}));

export const dialogs = {
  confirm: (req: ConfirmRequest) => useDialogStore.getState().openConfirm(req),
  error: (req: ErrorRequest) => useDialogStore.getState().openError(req),
};
